"use client";

import { PhoneIcon } from "@heroicons/react/24/solid";
import { trackPhoneClick } from "@/lib/tracking";

const PHONE_NUMBER = "+32493966507";

export default function PhoneCallButton({
  children = "Appeler maintenant",
  location = "unknown",
  className = "",
  icon = true,
}) {
  return (
    <a
      href={`tel:${PHONE_NUMBER}`}
      onClick={(event) => trackPhoneClick(event, { phoneNumber: PHONE_NUMBER, location })}
      className={className}
    >
      {icon && <PhoneIcon className="h-5 w-5" />}
      {children}
    </a>
  );
}
